/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'ng2-translate/src/translate.pipe';
import * as import3 from 'ng2-translate/src/translate.service';
import * as import4 from '../../string-utils/time.pipe';
import * as import5 from './store-status-panel.component';
import * as import6 from '../../ui-elements/touchable.directive';
import * as import7 from '../../ui-elements/toggle/toggle.component.ngfactory';
import * as import8 from '../../ui-elements/toggle/toggle.component';
import * as import9 from '../../ordering-context/ordering-context.model';
const styles_StoreStatusPanelComponent:any[] = ([] as any[]);
export const RenderType_StoreStatusPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_StoreStatusPanelComponent,
  data: {}
}
);
function View_StoreStatusPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['open']),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'indicator';
    const currVal_1:any = ck(v,2,0,co.isOpen);
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_StoreStatusPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(('woa.label.common.day.' + (<any>(<any>v.parent).parent).context.$implicit)));
    ck(v,1,0,currVal_0);
  });
}
function View_StoreStatusPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'details-hours-item-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'details-hours-item-time-day'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'details-hours-item-time-hours'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours-start'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                    -\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours-end'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.first;
    ck(v,5,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'open-day-',(<any>v.parent).context.$implicit,'');
    ck(v,2,0,currVal_0);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'open-time-',(<any>v.parent).context.$implicit,'-start');
    ck(v,10,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,11,0,ck(v,12,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.start,'hh:mm a'));
    ck(v,11,0,currVal_3);
    const currVal_4:any = import0.ɵinlineInterpolate(1,'open-time-',(<any>v.parent).context.$implicit,'-end');
    ck(v,14,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,15,0,ck(v,16,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.end,'hh:mm a'));
    ck(v,15,0,currVal_5);
  });
}
function View_StoreStatusPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'details-hours-item-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'details-hours-item-time-day'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'closed-day-',(<any>v.parent).context.$implicit,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform(('woa.label.common.day.' + (<any>v.parent).context.$implicit)));
    ck(v,5,0,currVal_1);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'closed-time-',(<any>v.parent).context.$implicit,'');
    ck(v,9,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,10,0,import0.ɵnov(v,11).transform('woa.label.store-details.storeClosedForTheDay'));
    ck(v,10,0,currVal_3);
  });
}
function View_StoreStatusPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'details-hours-item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_3)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.storeOpeningHours.standardHours[v.context.$implicit].hours;
    ck(v,5,0,currVal_0);
    const currVal_1:any = co.store.storeOpeningHours.standardHours[v.context.$implicit].closedForTheDay;
    ck(v,10,0,currVal_1);
  },(null as any));
}
export function View_StoreStatusPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import4.WOATimePipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'details-title'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.StoreStatusPanelComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleHours(import0.ɵnov(v,17))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import6.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-title-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',[[
        'class',
        'details-title-toggle'
      ]
    ],(null as any),(null as any),(null as any),import7.View_ToggleComponent_0,import7.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import8.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,[[
        'hours',
        1
      ]
      ],(null as any),4,'div',[[
        'class',
        'details-hours'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_2)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import5.StoreStatusPanelComponent = v.component;
    const currVal_0:any = co.store;
    ck(v,2,0,currVal_0);
    const currVal_2:any = co.showHours;
    ck(v,14,0,currVal_2);
    const currVal_3:any = co.daysOfWeek;
    ck(v,20,0,currVal_3);
  },(ck,v) => {
    var co:import5.StoreStatusPanelComponent = v.component;
    const currVal_1:any = import0.ɵunv(v,10,0,import0.ɵnov(v,11).transform(co.statusLabel));
    ck(v,10,0,currVal_1);
  });
}
function View_StoreStatusPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-status-panel',([] as any[]),(null as any),(null as any),(null as any),View_StoreStatusPanelComponent_0,RenderType_StoreStatusPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import5.StoreStatusPanelComponent,[import9.OrderingContextModel],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const StoreStatusPanelComponentNgFactory:import0.ComponentFactory<import5.StoreStatusPanelComponent> = import0.ɵccf('woa-store-status-panel',import5.StoreStatusPanelComponent,View_StoreStatusPanelComponent_Host_0,{
  store: 'store',
  filteredOrderType: 'filteredOrderType'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RvcmUvc3RvcmUtc3RhdHVzLXBhbmVsL3N0b3JlLXN0YXR1cy1wYW5lbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9zdG9yZS9zdG9yZS1zdGF0dXMtcGFuZWwvc3RvcmUtc3RhdHVzLXBhbmVsLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RvcmUvc3RvcmUtc3RhdHVzLXBhbmVsL3N0b3JlLXN0YXR1cy1wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RvcmUvc3RvcmUtc3RhdHVzLXBhbmVsL3N0b3JlLXN0YXR1cy1wYW5lbC5jb21wb25lbnQudHMuU3RvcmVTdGF0dXNQYW5lbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJpbmRpY2F0b3JcIiAqbmdJZj1cInN0b3JlXCIgW25nQ2xhc3NdPVwieydvcGVuJzogaXNPcGVufVwiPlxuPC9kaXY+XG48ZGl2IGNsYXNzPVwiZGV0YWlsc1wiPlxuICAgIDxkaXYgY2xhc3M9XCJkZXRhaWxzLXRpdGxlXCIgKGNsaWNrKT1cInRvZ2dsZUhvdXJzKGhvdXJzKVwiIHdvYS10b3VjaGFibGU+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJkZXRhaWxzLXRpdGxlLWxhYmVsXCI+XG4gICAgICAgICAgICB7e3N0YXR1c0xhYmVsIHwgdHJhbnNsYXRlfX1cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDx3b2EtdG9nZ2xlIGNsYXNzPVwiZGV0YWlscy10aXRsZS10b2dnbGVcIiBbYWN0aXZlXT1cInNob3dIb3Vyc1wiPjwvd29hLXRvZ2dsZT5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzPVwiZGV0YWlscy1ob3Vyc1wiICNob3Vycz5cbiAgICAgICAgPGRpdiAqbmdGb3I9XCJsZXQgZGF5IG9mIGRheXNPZldlZWtcIiBjbGFzcz1cImRldGFpbHMtaG91cnMtaXRlbVwiPlxuICAgICAgICAgICAgPCEtLSBXSEVOIFRIRVJFIEFSRSBPUEVOSU5HIEhPVVJTIC0tPlxuICAgICAgICAgICAgPCEtLXN1cHByZXNzIEpTVW5yZXNvbHZlZFJlZmVyZW5jZSAtLT5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkZXRhaWxzLWhvdXJzLWl0ZW0tdGltZVwiICpuZ0Zvcj1cImxldCBob3VycyBvZiBzdG9yZS5zdG9yZU9wZW5pbmdIb3Vycy5zdGFuZGFyZEhvdXJzW2RheV0uaG91cnM7IGZpcnN0IGFzIGlzRmlyc3RcIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZGV0YWlscy1ob3Vycy1pdGVtLXRpbWUtZGF5XCIgaWQ9XCJvcGVuLWRheS17e2RheX19XCI+XG4gICAgICAgICAgICAgICAgICAgIDxuZy1jb250YWluZXIgKm5nSWY9XCJpc0ZpcnN0XCI+e3snd29hLmxhYmVsLmNvbW1vbi5kYXkuJyArIGRheSB8IHRyYW5zbGF0ZX19PC9uZy1jb250YWluZXI+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImRldGFpbHMtaG91cnMtaXRlbS10aW1lLWhvdXJzXCI+XG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkZXRhaWxzLWhvdXJzLWl0ZW0tdGltZS1ob3Vycy1zdGFydFwiIGlkPVwib3Blbi10aW1lLXt7ZGF5fX0tc3RhcnRcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIHt7aG91cnMuc3RhcnQgfCB3b2FUaW1lOidoaDptbSBhJ319XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAtXG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkZXRhaWxzLWhvdXJzLWl0ZW0tdGltZS1ob3Vycy1lbmRcIiBpZD1cIm9wZW4tdGltZS17e2RheX19LWVuZFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAge3tob3Vycy5lbmQgfCB3b2FUaW1lOidoaDptbSBhJ319XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8IS0tIFdIRU4gU1RPUkUgSVMgQ0xPU0VEIEZPUiBUSEUgREFZIC0tPlxuICAgICAgICAgICAgPCEtLXN1cHByZXNzIEpTVW5yZXNvbHZlZFJlZmVyZW5jZSAtLT5cbiAgICAgICAgICAgIDxkaXYgKm5nSWY9XCJzdG9yZS5zdG9yZU9wZW5pbmdIb3Vycy5zdGFuZGFyZEhvdXJzW2RheV0uY2xvc2VkRm9yVGhlRGF5XCJcbiAgICAgICAgICAgICAgICAgY2xhc3M9XCJkZXRhaWxzLWhvdXJzLWl0ZW0tdGltZVwiPlxuICAgICAgICAgICAgICAgIDxkaXYgaWQ9XCJjbG9zZWQtZGF5LXt7ZGF5fX1cIiBjbGFzcz1cImRldGFpbHMtaG91cnMtaXRlbS10aW1lLWRheVwiPlxuICAgICAgICAgICAgICAgICAgICA8bmctY29udGFpbmVyPnt7J3dvYS5sYWJlbC5jb21tb24uZGF5LicgKyBkYXkgfCB0cmFuc2xhdGV9fTwvbmctY29udGFpbmVyPlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDxkaXYgaWQ9XCJjbG9zZWQtdGltZS17e2RheX19XCIgY2xhc3M9XCJkZXRhaWxzLWhvdXJzLWl0ZW0tdGltZS1ob3Vyc1wiPlxuICAgICAgICAgICAgICAgICAgICB7eyd3b2EubGFiZWwuc3RvcmUtZGV0YWlscy5zdG9yZUNsb3NlZEZvclRoZURheScgfCB0cmFuc2xhdGV9fVxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuPC9kaXY+XG5cbiIsIjx3b2Etc3RvcmUtc3RhdHVzLXBhbmVsPjwvd29hLXN0b3JlLXN0YXR1cy1wYW5lbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFxQztJQUE2Qjs7OztJQUE3RDtJQUFnQztJQUFyQyxTQUFLLFVBQWdDLFNBQXJDOzs7OztJQWVvQjtJQUE4QjtNQUFBO01BQUE7SUFBQTtJQUFBO2dCQUFBOzs7SUFBQTtJQUFBOzs7SUFBQTtJQUFBOzs7OztNQUZ0QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQThIO01BQzFIO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQStEO0lBQzNEO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMEY7SUFDeEY7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTJDO01BQ3ZDO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQThFO01BQUE7TUFBQTtJQUFBO0lBQUE7Z0JBQUE7SUFFeEU7TUFFTjtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEwRTtNQUFBO01BQUE7SUFBQTtJQUFBO2dCQUFBO0lBRXBFO0lBQ0o7OztJQVZZO0lBQWQsU0FBYyxTQUFkOztJQURxQztJQUF6QyxTQUF5QyxTQUF6QztJQUlxRDtJQUFqRCxVQUFpRCxTQUFqRDtJQUE4RTtJQUFBO0lBSS9CO0lBQS9DLFVBQStDLFNBQS9DO0lBQTBFO0lBQUE7Ozs7O01BT2xGO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDcUM7TUFDakM7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUU7SUFDN0Q7SUFBYztNQUFBO01BQUE7SUFBQTtJQUFBO2dCQUFBOzs7SUFBQTtJQUFBO0lBQTREO0lBQ3hFO01BQ047UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBb0U7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTs7O0lBQUE7SUFBQTtJQUU5RDs7O0lBTEQ7SUFBTCxTQUFLLFNBQUw7SUFDa0I7SUFBQTtJQUViO0lBQUwsU0FBSyxTQUFMO0lBQW9FO0lBQUE7Ozs7O01BeEI1RTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQStEO0lBQ3RCO0lBQ0M7SUFDdEM7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFhTTtJQUNtQztJQUNIO0lBQ3RDO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFRTTs7OztJQXhCK0I7SUFBckMsU0FBcUMsU0FBckM7SUFnQks7SUFBTCxVQUFLLFNBQUw7Ozs7OztJQTdCWjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQ007TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFCO0lBQ2pCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUEyQjtRQUFBO1FBQUE7TUFBQTtNQUEzQjtJQUFBO2dCQUFBO0lBQXNFO01BQ2xFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUM7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTs7O0lBQUE7SUFBQTtJQUUzQjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyRTtJQUN6RTtNQUNOO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrQztJQUM5QjtnQkFBQTs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQTRCTTtJQUNKO0lBQ0o7Ozs7SUF4Q2lCO0lBQXZCLFNBQXVCLFNBQXZCO0lBT2lEO0lBQXpDLFVBQXlDLFNBQXpDO0lBR0s7SUFBTCxVQUFLLFNBQUw7OztJQU5pQztJQUFBOzs7OztJQ0p6QztnQkFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/store/store-status-panel/store-status-panel.component.ngfactory.ts